import { getCoreState } from './core-state';
import { ChildReducerName } from '../constants/other';
export const getGeneralState = (state) => getCoreState(state)[ChildReducerName.general];
export const getLocale = (state) => getGeneralState(state).locale;
